// extracted by mini-css-extract-plugin
module.exports = {"bodyMedium":"_2OkcqF","bodySmall":"_19S1wl","shortcutButtonsBlock":"ohNKm7","disableTopPadding":"_2ubnJd","container":"_1Zk0ZV"};